<template>
<!-- 
xs(Extra Small)・・・主にスマホ対応
sm(Small)・・・主にタブレット
md(Medium) ・・・主にノートパソコンや横表示のタブレット
lg(Large)・・・主にデスクトップ
xl(Extra large)・・・4Kや大きなモニター 


v-if="$vuetify.breakpoint.xs"
-->
    <div>
        <template v-if="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm || $vuetify.breakpoint.md">
            <v-container fluid>
                <v-row v-if="!isShareMode" dense>
                    <v-col cols="12">
                        <Notification ref="notificationViewer" />
                    </v-col>
                </v-row>
                <v-row align="center" justify="center" dense>
                    <ButtonGroup @onClick="onClick" @onClickUserLicense="onClickUserLicense" @onClickSetLicense="onClickSetLicense" @onClickCustomize="onClickCustomize" />
                </v-row>
            </v-container>
        </template>
        <template v-else>
            <v-container fluid>
                <v-row>
                    <v-col cols="6" lg="4" xl="6" align="center" class="pt-0">
                        <ButtonGroup @onClick="onClick" @onClickUserLicense="onClickUserLicense" @onClickSetLicense="onClickSetLicense" @onClickCustomize="onClickCustomize" />
                    </v-col>
                    <v-col cols="6" lg="8" xl="6">
                        <Notification ref="notificationViewer" />
                        <Boxes />
                    </v-col>
                </v-row>
            </v-container>
        </template>
        <VerificatorLicense ref="verificator" />
        <UserLicense ref="userLicense" />
        <Confirm ref="confirm" />
    </div>
</template>

<script>
    Date.prototype.toFormatString = function (format) {
        const year = this.getFullYear()
        const month = this.getMonth() + 1
        const month2 = ("0" + month).slice(-2)
        const day2 = ("0" + this.getDate()).slice(-2)
        const hour2 = ("0" + this.getHours()).slice(-2)
        const minute2 = ("0" + this.getMinutes()).slice(-2)
        const second2 = ("0" + this.getSeconds()).slice(-2)

        const formattedValue = format.replace("yyyy", year).replace("MM", month2).replace("dd", day2).replace("HH", hour2).replace("mm", minute2).replace("ss", second2)

        return formattedValue
    }

    import db from '@/firebase/firestore.js'
    import Notification from '@/components/title/NotificationList';
    import ScheduleList from '@/components/title/ScheduleList';
    import ButtonGroup from '@/components/title/TitleButtonGroup';
    import Boxes from '@/components/title/BoxesInformation';
    import Weather from '@/components/tools/WeatherViewer3';
    import VerificatorLicense from '@/components/tools/LicenseVerificator';
    import UserLicense from '@/components/tools/UserLicenseViewer';
    import Confirm from '@/components/tools/ConfirmDialog';
    // import ValueSetter from '@/components/tools/CustomNumber';
    // import JSMpeg from '@/vue-jsmpeg.js'
    export default {
        name: 'Title',
        components: {
            Notification,
            ScheduleList,
            ButtonGroup,
            Boxes,
            Weather,
            VerificatorLicense,
            UserLicense,
            Confirm
            // ValueSetter
            // TEST
        },
        computed: {
            loginState: function () {
                return this.$store.getters["loginState"]
            },
            userUID: function () {
                return this.$store.getters["loggedInUserUID"]
            },
            userData: function () {
                return this.$store.getters["loggedInUserData"]
            },
            userLicense: function () {
                return this.$store.getters["loggedInUserLicense"]
            },
            /** グループユーザーの圃場管理を参照中は True */
            isShareMode: function () {
                if (this.$store.getters["shareMode"] == this.$store.getters["shareModeTypes"].groupUserWork) {
                    return true
                }
                return false
            },
            buttonGroupWidth: function () {
                return this.buttonGroupColumnNum * 120
            },
            buttonGroupHeight: function () {
                return this.buttonGroupRowNum * 120
            },
            /** ボタングループの列数 */
            buttonGroupColumnNum: function () {
                return 3 // this.$vuetify.breakpoint.xs ? 3 : 5
            },
            /** ボタングループの行数 */
            buttonGroupRowNum: function () {
                return 5 // this.$vuetify.breakpoint.xs ? 5 : 3
            },
            /** 指定された位置のボタン */
            button: function () {
                return function (x, y) {
                    const buttonNo = (y - 1) * this.buttonGroupColumnNum + x
                    return this.buttons.find((v)=>v.position == buttonNo && (this.isShareMode ? v.share : v.nonShare))
                }
            },
            /** 指定された位置のボタンに表示する画像のパス */
            buttonIconPath: function () {
                return function(x, y) {
                    const button = this.button(x, y)
                    if (button.icon == "") return ""
                    return require("@/assets/icons/"+(button.icon)+".png")
                }
            },
        },
        data: function () {
            return {
                // test: 0,
                test:0,
                isView: false,
                // buttons: [
                //     {name:"place", icon: "mdi-home-city", tip:"圃場管理", color:"#008FFF", share: true, nonShare: true},
                //     {name:"seedling", icon: "mdi-sprout", tip:"苗管理", color:"green lighten-1", share: true, nonShare: true},
                //     {name:"notification", icon: "mdi-send", tip:"通知管理", color:"primary", share: false, nonShare: true},
                //     {name:"group", icon: "mdi-home-group", tip:"グループ管理", color:"brown lighten-1", share: false, nonShare: true},
                //     {name:"camera", icon: "mdi-camera", tip:"撮影", color:"primary", share: false, nonShare: true},
                //     {name:"knowledge", icon: "mdi-head-snowflake-outline", tip:"知識バンク", color:"red lighten-1", share: true, nonShare: true},
                //     {name:"endShare", icon: "mdi-exit-run", tip:"自分の圃場管理に戻る", color:"primary", share: true, nonShare: false},
                // ],
                buttons: [
                    { name:"place", icon: "home_place", tip:"圃場", share: true, nonShare: true, position: 1 },
                    { name:"today_works", icon: "home_work", tip:"本日の作業", share: true, nonShare: true, position: 2 },
                    { name:"seedling", icon: "home_seedling", tip:"苗", share: true, nonShare: true, position: 3 },
                    { name:"box", icon: "home_box", tip:"環境BOX", share: true, nonShare: true, position: 4 },
                    { name:"notification", icon: "home_notification", tip:"通知", share: false, nonShare: true, position: 5 },
                    { name:"group", icon: "home_group", tip:"グループ", share: false, nonShare: true, position: 6 },
                    { name:"endShare", icon: "home_return_myhome", tip:"戻る", share: true, nonShare: false, position: 6 },
                    { name:"camera", icon: "home_album", tip:"アルバム", share: false, nonShare: true, position: 7 },
                    { name:"knowledge", icon: "home_knowledge", tip:"知識バンク", share: true, nonShare: true, position: 8 },
                    { name:"memo", icon: "home_memo", tip:"メモ", share: true, nonShare: true, position: 9 },
                    { name:"setting", icon: "home_setting", tip:"設定", share: true, nonShare: true, position: 10 },
                    { name:"weather", icon: "", tip:"", share: true, nonShare: true, position: 11 },
                    { name:"license", icon: "home_license", tip:"", share: true, nonShare: true, position: 12 },
                ],
                scheduleItems: {
                    schedules: [],
                    year: 0,
                    month: 0
                },
                blocks: [],
                isLicenseChecking: false
            }
        },
        created: function () {
            // console.log("Title", "created")

            const self = this

            // ライセンスを所持している時は、そのライセンスの状態をチェック
            console.log("Title", "created", this.userData)
            if (this.userData != null && this.userData.license != null) {
                this.checkLicenseState()
            } else {
                this.$store.commit("userLicense", null)
            }
        },
        methods: {
            onClickTestOpen: function () {
                console.log("onClickTestOpen")
                const self = this
                this.$store.commit("processing", {start:true, message:"テスト…。"})
                // setTimeout(function() {
                //     self.$store.commit("processing")
                // } , 5000)
            },
            /**
             * ボタングループのカスタマイズボタン押下時
             */
            onClickCustomize: function () {
                this.$refs.confirm.show({
                    title: "レイアウトのカスタマイズ",
                    message: "現在、この機能は実装されておりません。",
                    buttonYes: "戻る",
                    buttonNo: ""
                })
            },
            onClick: function (button) {
                console.log("onClick")
                this.$emit("onClickTitleMenuButton", button.name)
            },
            /**
             * ライセンス設定ボタン押下時
             */
            onClickSetLicense: function () {
                this.$refs.verificator.show(this.verificatedLicense)
            },
            /**
             * ライセンスのアバターボタン押下時
             */
            onClickUserLicense: function () {
                // console.log("onClickUserLicense")
                this.$refs.userLicense.show(this.userLicense)
            },
            /**
             * ライセンス認証画面での認証結果を受け取るコールバック
             */
            verificatedLicense: function (result) {
                
                const self = this

                switch (result.result) {
                    case "ERROR_LICENSE_0001":
                    case "ERROR_LICENSE_0002":
                        this.showLicenseNG(result.result)
                        return
                }

                /** ライセンスデータ有り、パスワードOKの時は有効化されているかをチェック */
                if (!result.license.licenseInfo.activated) {
                    this.showLicenseNG("ERROR_LICENSE_0004")
                    return
                }

                /** 無効化されているかをチェック */
                if (result.license.deactivated) {
                    this.showLicenseNG("ERROR_LICENSE_0006")
                    return
                }

                /** ライセンス数をチェックして、ライセンス数に問題なければユーザーデータにライセンス情報をセットして更新 */
                db.collection("users").where("license.code", "==", result.license.code).get().then(function(snapShot){
                    const licensedNum = snapShot.size
                    if (licensedNum >= result.license.licenseInfo.licenseNum) {
                        self.showLicenseNG("ERROR_LICENSE_0005")
                        return
                    }

                    const currentDateTime = new Date()

                    self.userData.license = {
                        code: result.license.code,
                        isLicenseManager: false,
                        dateTime: currentDateTime.toFormatString("yyyy-MM-dd HH:mm:ss")
                    }

                    db.collection("users").doc(self.userData.userUID).set(self.userData).then(function(){
                        self.$store.commit("notification", {message:"ライセンスを設定しました。", isError: false})
                        self.$store.commit("userLicense", result.license)
                    }).catch (function(error){
                        console.log(error)
                        self.$store.commit("notification", {message:"ライセンス設定に失敗しました。"+error, isError: true})
                    })
                }).catch (function(error) {
                    self.mi_writeLog("Title/verificatedLicense", "ライセンス数チェック失敗("+error+")")
                })
            },
            /**
             * ライセンス状態のチェック
             */
            checkLicenseState: function () {

                const self = this

                // ライセンスが登録されているかチェック
                const currentDateTime = new Date()
                
                // console.log("Title", "checkLicense", "start ==================================== ")
                this.$store.commit("userLicense", null)

                this.isLicenseChecking = true

                db.collection("licenses")
                .where("code", "==", this.userData.license.code)
                .where("deactivated", "==", false)
                .where("licenseInfo.activated", "==", true)
                .get().then(function(snapShot){

                    if (snapShot.size == 0) {
                        // console.log("Title", "checkLicense", "license data not exist or not enabled or deactivated!!")
                        self.isLicenseChecking = false
                    } else {
                        // console.log("Title", "checkLicense", "license data enabled")
                        const license = snapShot.docs[0].data()
                        // ライセンスの有効期限内か？
                        if (currentDateTime.toFormatString("yyyy-MM-dd") > license.licenseInfo.toDate) {
                            // console.log("Title", "checkLicense", "license data effective date over!!")
                            self.isLicenseChecking = false
                        } else {
                            // console.log("Title", "checkLicense", "license data effective date ok")
                            // 除外リストに登録されているか？
                            db.collection("licenses").doc(self.userData.license.code).collection("exclusion_users").doc(self.userUID).get().then(function(doc){
                                if (doc.exists) {
                                    // console.log("Title", "checkLicense", "license data registered exclusion user!!")
                                } else {
                                    // ライセンスOK
                                    // console.log("Title", "checkLicense", "license data not registered exclusion user")
                                    self.$store.commit("userLicense", license)
                                }
                                self.isLicenseChecking = false
                            }).catch (function(error) {
                                self.mi_writeLog("Title/checkLicenseState", "ライセンスの除外チェック失敗("+error+")")
                            })
                        }
                    }
                }).catch (function(error) {
                    self.mi_writeLog("Title/checkLicenseState", "ライセンスの状態チェック失敗("+error+")")
                })
            },
            /**
             * ライセンス不可時のダイアログを表示
             */
            showLicenseNG: function (result) {
                this.$refs.confirm.show({
                    title: "ライセンス認証",
                    message: "ライセンスの認証エラー("+result+")",
                    buttonYes: "戻る",
                    buttonNo: ""
                })
            },
            /**
             * 通知更新
             */
            refreshNotifications: function () {
                this.$refs.notificationViewer.refresh()
            }
        }
    }
</script>
